import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseCacheService } from 'src/app/core/base/base-cache.service';
import { ApiResponse } from 'src/app/shared/models/api.response';
import { ConfigService } from 'src/app/shared/services/utils/config.service';
import { eFolderFeature } from '../enum/folder-feature.enum';

@Injectable({ providedIn: 'root' })
export class FolderApiService extends BaseCacheService<any> {
  public constructor(http: HttpClient, configService: ConfigService) {
    super(eFolderFeature.apiPath, http, configService);
  }

  public createFolders(data: any): Observable<ApiResponse<any>> {
    return this.post<ApiResponse<any>>(eFolderFeature.apiPath, data);
  }

  public updateFolders(data: any): Observable<ApiResponse<any>> {
    return this.patch<ApiResponse<any>>(eFolderFeature.archivedFolderPath, data);
  }

  public getArchivedFolder(data: any): Observable<ApiResponse<any>> {
    return this.get<ApiResponse<any>>(eFolderFeature.archivedFolderPath, data);
  }

  public getArchivedAudit(data: any): Observable<ApiResponse<any>> {
    return this.get<ApiResponse<any>>(`${eFolderFeature.archivedAuditsPath}/${data['folderId']}`, data);
  }

  public createArchivedAudits(data: any): Observable<ApiResponse<any>> {
    return this.post<ApiResponse<any>>(eFolderFeature.archivedAuditsPath, data);
  }

  public deleteArchiveAudit(data: any): Observable<ApiResponse<any>> {
    return this.delete<ApiResponse<any>>(
      `${eFolderFeature.archivedAuditsPath}?folderId=${data['folderId']}&companyId=${data['companyId']}&archivedAuditId=${data['archivedAuditId']}`,
      undefined,
      data
    );
  }

  public unArchiveAudit(data: any): Observable<ApiResponse<any>> {
    const query = [
      `folderId=${encodeURIComponent(data['folderId'] ?? '')}`,
      `companyId=${encodeURIComponent(data['companyId'] ?? '')}`,
      `auditId=${encodeURIComponent(data['auditId'] ?? data['id'] ?? '')}`,
      `id=${encodeURIComponent(data['id'] ?? data['auditId'] ?? '')}`,
      `archivedAuditId=${encodeURIComponent(data['archivedAuditId'] ?? data['auditId'] ?? data['id'] ?? '')}`,
      `auditType=${encodeURIComponent(data['auditType'] ?? '')}`,
    ].join('&');
    return this.post<ApiResponse<any>>(`${eFolderFeature.unarchivedAuditsPath}?${query}`, data);
  }

  public deleteFolder(data: any): Observable<ApiResponse<any>> {
    return this.delete<ApiResponse<any>>(`${eFolderFeature.archivedFolderPath}?folderId=${data['folderId']}`, undefined, data);
  }
}
